import { mainAPI } from "../api";
import {
  ColleagueForSelector,
  ColleaguesListResponse,
  UsersListResponse,
} from "../types/users";
import { getUserFioShort } from "../helpers/users";

export function fetchUsersByIdList(ids: string[] | undefined) {
  if (!ids) {
    return;
  }
  let queryParams = `?id=${ids.join(",")}`;
  return mainAPI.get<UsersListResponse>(`/users/${queryParams}`).then(
    (res) => {
      return Promise.resolve(res.data);
    },
    (error) => {
      return Promise.reject(error);
    }
  );
}

export function uploadAvatar(file: File) {
  let bodyFormData = new FormData();
  bodyFormData.append("photo", file);

  return mainAPI
    .patch(`users/own/change/`, bodyFormData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then(
      (res) => {
        return Promise.resolve(res.data);
      },
      (error) => {
        return Promise.reject(error);
      }
    );
}

export function fetchMyColleagues(
  limit: number,
  offset: number,
  search?: string
): Promise<Array<ColleagueForSelector>> {
  return mainAPI
    .get<ColleaguesListResponse>(`users/colleagues/of_user/`, {
      params: {
        limit,
        offset,
        search,
      },
    })
    .then(
      (res) => {
        return Promise.resolve(
          res.data.results.map((e) => {
            let res: ColleagueForSelector = {
              pk: e.pk,
              name: getUserFioShort(e),
              post: e.post,
              department: e.department,
              brand: e.brand,
            };
            return res;
          })
        );
      },
      (error) => {
        return Promise.reject(error);
      }
    );
}

export function fetchColleagues(
  limit: number,
  offset: number,
  search?: string
): Promise<Array<ColleagueForSelector>> {
  return mainAPI
    .get<ColleaguesListResponse>(`users/colleagues/`, {
      params: {
        limit,
        offset,
        search,
      },
    })
    .then(
      (res) => {
        return Promise.resolve(
          res.data.results.map((e) => {
            let res: ColleagueForSelector = {
              pk: e.pk,
              name: getUserFioShort(e),
              post: e.post,
              department: e.department,
              brand: e.brand,
            };
            return res;
          })
        );
      },
      (error) => {
        return Promise.reject(error);
      }
    );
}

export function fetchUsersByRole(
  limit: number,
  offset: number,
  search?: string,
  role?: number | string
): Promise<Array<ColleagueForSelector>> {
  return mainAPI
    .get<UsersListResponse>(`users/`, {
      params: {
        limit,
        offset,
        search,
        role,
      },
    })
    .then(
      (res) => {
        return Promise.resolve(
          res.data.results.map((e) => {
            let res: ColleagueForSelector = {
              pk: e.pk,
              name: getUserFioShort(e),
              post: e.post,
              department: e.department,
              brand: e.brand,
            };
            return res;
          })
        );
      },
      (error) => {
        return Promise.reject(error);
      }
    );
}
